import type { AuditHistoryContext } from "@playbookai/types";
import { auditObjectLabel } from "./audit-vocabulary.js";

/** Display only the saved, bounded context emitted by the audit read API. */
export function auditHistorySummary(
  context: AuditHistoryContext,
  names: ReadonlyMap<string, string> = new Map(),
): string {
  const parts: string[] = [];
  if (context.reorderedItems?.length)
    parts.push(
      `Reordered: ${context.reorderedItems.map((item) => `${auditObjectLabel(item.type)} “${item.title}”`).join("; ")}`,
    );
  for (const change of context.parkingChanges ?? [])
    parts.push(
      `${change.action === "parked" ? "Parked" : "Unparked"}: ${change.item}`,
    );
  for (const dot of context.removedDots ?? [])
    parts.push(`Removed dot between ${dot.fromTitle} and ${dot.toTitle}`);
  if (context.votesPerPerson)
    parts.push(`Votes per person: ${context.votesPerPerson}`);
  const target = context.targetChange;
  if (target) {
    const value = (v: string | null) => (v === null ? "Unset" : String(v));
    const date = (v: string | null) => (v === null ? "Unset" : v.slice(0, 10));
    parts.push(
      `Baseline: from ${value(target.before.baseline)} to ${value(target.after.baseline)}`,
      `Target: from ${value(target.before.targetValue)} to ${value(target.after.targetValue)}`,
      `By date: from ${date(target.before.byDate)} to ${date(target.after.byDate)}`,
    );
  }
  const owner = context.ownerChange;
  if (owner) {
    const name = (id: string | null) =>
      id === null ? "Unassigned" : (names.get(id) ?? "A member");
    parts.push(
      `Owner: from ${name(owner.beforeUserId)} to ${name(owner.afterUserId)}`,
    );
  }
  return parts.join("; ");
}
